import { RoundtableTypeEnum } from "@@types/type";

export const ProjectColorMappingByType = {
  [RoundtableTypeEnum.FREELANCER]: "common.bulmaHair",
  [RoundtableTypeEnum.SELF]: "primary.main",
  [RoundtableTypeEnum.TEAM]: "primary.main",
  [RoundtableTypeEnum.EXTERNAL_FREELANCER]: "primary.main",
  [RoundtableTypeEnum.EXTERNAL_SELF]: "primary.main",
};
